import React from 'react';
import { useParams } from 'react-router-dom';

const SubcategoryPage = () => {
  const { categorySlug, subcategorySlug } = useParams();
  return <div />;
};

export default SubcategoryPage;